var checkIsTouchDevice = function checkIsTouchDevice() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  } // return 'ontouchstart' in window || navigator.msMaxTouchPoints > 0

};

export { checkIsTouchDevice };
//# sourceMappingURL=check_is_touch_device.js.map
